<template>
  <p class="archax-footer" v-if="geoIsUK">
    {{ $t('ArchaxFooter.text.disclaimer') }}
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { checkGeo } from '@/composables/helpers/useDetectedGeo';

const geoIsUK = computed(() => checkGeo('GB'));

</script>
<style lang="scss">
.archax-footer {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  margin-top: auto;
  color: var(--footer-text-color);
}
</style>
